const buttonGroupContextKey = /* @__PURE__ */ Symbol(
  "buttonGroupContextKey"
);

export { buttonGroupContextKey };
//# sourceMappingURL=constants.mjs.map
